import { ReactNode } from 'react';
import { Space, SpaceProps } from 'antd';
import { observer } from 'mobx-react-lite';

import styles from './stack.module.css';

type StackProps = {
  children: ReactNode | ReactNode[];
} & SpaceProps;

export const Stack = observer(({ children, ...props }: StackProps) => {
  return (
    <Space
      direction="vertical"
      size="middle"
      {...props}
      className={styles.container}
    >
      {children}
    </Space>
  );
});
